import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { toastr } from 'react-redux-toastr';
import { getAllControllingPersons } from './getAllControllingPersons';

export const REMOVE_CONTROLLING_PERSON_REQUEST = 'REMOVE_CONTROLLING_PERSON_REQUEST';
export const REMOVE_CONTROLLING_PERSON_SUCCESS = 'REMOVE_CONTROLLING_PERSON_SUCCESS';
export const REMOVE_CONTROLLING_PERSON_FAILURE = 'REMOVE_CONTROLLING_PERSON_FAILURE';

function removeControllingPersonRequest() {
  return {
    type: REMOVE_CONTROLLING_PERSON_REQUEST
  };
}

function removeControllingPersonRecieved() {
  return {
    type: REMOVE_CONTROLLING_PERSON_SUCCESS,
  };
}

function removeControllingPersonFailed() {
  return {
    type: REMOVE_CONTROLLING_PERSON_FAILURE,
  };
}

export function removeControllingPerson(controllingPersonId, accountId) {
  return (dispatch) => {
    dispatch(removeControllingPersonRequest());
    const promise = () => ApiService
      .removeControllingPerson(controllingPersonId, accountId)
      .then((response) => {
        dispatch(removeControllingPersonRecieved());
        toastr.success('Success', 'Controlling person removed successfully');
        dispatch(getAllControllingPersons(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, removeControllingPersonFailed, true));
        }
      });
    return promise();
  };
}
